import React from 'react';
import { INTERFACE_TEXT } from '../../constants/interfaceText';
import styles from './TopBar.module.css';

interface TopBarProps {
  title: string;
  onPause: () => void;
  onLeave: () => void;
  /** Pause does nothing at the intro and the debrief. */
  pauseDisabled?: boolean;
  /** Accessible name of the leave button. */
  label?: string;
}

export const TopBar: React.FC<TopBarProps> = ({
  title,
  onPause,
  onLeave,
  pauseDisabled = false,
  label = INTERFACE_TEXT.tsLeaveAria,
}) => (
  <div className={styles.bar}>
    <button
      type="button"
      className={styles.btn}
      onClick={onPause}
      disabled={pauseDisabled}
    >
      {INTERFACE_TEXT.tsPause}
    </button>
    <span className={styles.title}>{title}</span>
    <button
      type="button"
      className={`${styles.btn} ${styles.leave}`}
      onClick={onLeave}
      aria-label={label}
    >
      <span aria-hidden="true">✕</span>
    </button>
  </div>
);

export default TopBar;
